
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { GlobalConstants } from '../../common/global-constants';
import { BOSellDataSended } from '../../models/BOSellDataSended.model';
import { BOFilter } from '../../models/BOFilter';
import { BOToothQuote } from '../../models/odo/BOToothQuote.model';

@Injectable({
  providedIn: 'root'
})
export class ToothQuoteService
{
    myAppUrl = GlobalConstants.apiURL;
    //myAppURlLocal= GlobalConstants.apiURlLocal;
    myApiUrl = 'api/Quote/';
    dataSell:BOSellDataSended= new BOSellDataSended();
    private areaSubject = new BehaviorSubject<number>(0);

    dataSellBhSubject$= new BehaviorSubject<BOSellDataSended>(this.dataSell);
    area$ = this.areaSubject.asObservable();

    constructor(private http:HttpClient){}

    saveQuote(quote:BOToothQuote):Observable<BOToothQuote>{
      const httpOptions = {
          headers: new HttpHeaders({'Content-Type': 'application/json'})
        }
        const body=JSON.stringify(quote);
      return this.http.post<BOToothQuote>(this.myAppUrl + this.myApiUrl+'saveToothQuote',body,httpOptions);
    }


    getAll(filter:BOFilter):Observable<BOToothQuote[]>
    {
      const httpOptions = {
          headers: new HttpHeaders({'Content-Type': 'application/json'})
        }
        const body=JSON.stringify(filter);
      return this.http.post<BOToothQuote[]>(this.myAppUrl + this.myApiUrl + 'getAll',body,httpOptions);
    }

    getToothQuote(quoteId:number):Observable<BOToothQuote>
    {
      return this.http.get<BOToothQuote>(this.myAppUrl + this.myApiUrl + 'getToothQuote/'+quoteId);

    }
    getAllQuotesByCh(quoteId:number):Observable<BOToothQuote[]>
    {
      return this.http.get<BOToothQuote[]>(this.myAppUrl + this.myApiUrl + 'getAllQuotesByCh/'+quoteId);

    }
    deleteItem(itemId:number):Observable<any>{
        return this.http.delete<any>(this.myAppUrl + this.myApiUrl + 'delete/' + itemId);
    }
}


